import { useNavigate, useLocation } from "react-router-dom";
import { useCourseDetailStore } from "@/stores/courseDetailStore";
import {
  useSectionCompletionStore,
  sectionKey,
} from "@/stores/sectionCompletionStore";
import { useCourseBasePath } from "@/hooks/useCourseBasePath";
import { SectionContent } from "@/components/course/SectionContent";
import { MODULE_INTRO_FALLBACK } from "@/components/course/introFallbacks";
import { CourseTreeNodeTypeEnum, type CourseTreeNode } from "@/types/generated";

interface ModuleIntroPageProps {
  module: CourseTreeNode;
}

export const ModuleIntroPage = ({ module }: ModuleIntroPageProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = useCourseBasePath();
  const { courseData } = useCourseDetailStore();
  const markCompleted = useSectionCompletionStore((s) => s.markCompleted);

  const modules =
    courseData?.structure?.filter(
      (n) => n.type === CourseTreeNodeTypeEnum.Module
    ) ?? [];
  const idx = modules.findIndex((m) => m.id === module.id);
  const moduleLabel =
    idx >= 0 && modules.length > 0
      ? `Modul ${idx + 1} von ${modules.length}`
      : undefined;

  const firstChapter = module.children?.find(
    (c) => c.type === CourseTreeNodeTypeEnum.Chapter
  );

  const handleStart = () => {
    markCompleted(sectionKey("intro", module.id));
    if (firstChapter) {
      navigate(`${basePath}/${firstChapter.id}${location.search}`);
    }
  };

  return (
    <SectionContent
      badge={moduleLabel}
      title={module.title}
      body={module.intro || MODULE_INTRO_FALLBACK}
      ctaLabel="Los geht's"
      onStart={firstChapter ? handleStart : undefined}
    />
  );
};
